import { createStore } from '@servicetitan/financing-utils-shared';
import { ComponentType, PropsWithChildren, useState } from 'react';
import { ButtonProps } from '@servicetitan/anvil2';

export interface WorkflowButtons {
    DoneButton: ComponentType<PropsWithChildren<ButtonProps>>;
    CancelApplicationButton: ComponentType<PropsWithChildren<ButtonProps>>;
    CloseWithoutConfirmingButton: ComponentType<PropsWithChildren<ButtonProps>>;
    ViewOfferDetailsButton?: ComponentType<PropsWithChildren<ButtonProps>>;
    onCloseWorkflow?: () => void;
}

function useWorkflowButtons(initialState: WorkflowButtons) {
    const [buttons] = useState<WorkflowButtons>(initialState);
    return buttons;
}

export const WorkflowButtonsStore = createStore(useWorkflowButtons);

export type WorkflowButtonsStoreValue = ReturnType<typeof useWorkflowButtons>;
